import type { QuickAnswerKind } from '@numeo/types'

/** The general agent's page: the invoicing chat. Page load opens a new empty chat (v17). */
export const GENERAL_AGENT_PAGE_PATH = '/agent'

/** The server's tab ids are UUIDs (general-agent-service `helpers/uuid`); any other id in a chat URL is refused. */
const TAB_ID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

/** Whether a route's chat id has the server's shape, so the page never asks the API for anything else. */
export const isAgentTabId = (value: string | undefined): value is string => typeof value === 'string' && TAB_ID_RE.test(value)

/** The three suggestions of the empty chat: each is answered by a quick answer, without the model (decision 10). */
export const INVOICING_SUGGESTIONS: ReadonlyArray<{ kind: QuickAnswerKind; label: string }> = [
    { kind: 'ready', label: 'Check delivered loads' },
    { kind: 'attention', label: 'What needs my attention?' },
    { kind: 'submit', label: 'Submit invoices' },
]
